// 滚动进入视口后才挂载子组件(延迟其网络请求/图片,移出首屏关键路径)。
import { useEffect, useRef, useState, type ReactNode } from 'react';

export default function InView({ children, minHeight = 320 }: { children: ReactNode; minHeight?: number }) {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      setShow(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: '300px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  // 始终保留 minHeight:占位→Suspense 加载→挂载全程容器恒高,不挤动下方内容(CLS)。
  return (
    <div ref={ref} style={{ minHeight }}>
      {show ? children : null}
    </div>
  );
}
